import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { default as App } from './App'
import { default as Store } from './store'
import { persistStore } from 'redux-persist'
import registerServiceWorker from './registerServiceWorker'
import { PersistGate } from 'redux-persist/integration/react'
import fontawesome from '@fortawesome/fontawesome'
import {
    faKey, faTrash, faEdit, faLock, faUnlock, faClipboard, faChevronLeft, faImage, faPlus, faEye
} from '@fortawesome/fontawesome-free-solid'

import './assets/css/bootstrap.min.css'
import './assets/sass/light-bootstrap-dashboard.css'
import './assets/css/demo.css'
import './assets/css/pe-icon-7-stroke.css'
import './index.css' //headers margin overwrite

fontawesome.library.add(faKey, faTrash, faEdit, faLock, faUnlock, faClipboard, faChevronLeft, faImage, faPlus, faEye)

ReactDOM.render((
    <Provider store={Store}>
        <PersistGate loading={null} persistor={persistStore(Store)}>
            <App />
        </PersistGate>
    </Provider>
), document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js